/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Mini Cart Drawer functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  const miniCart = document.getElementById('mini-cart');
  const cartToggle = document.querySelector('.header__cart-toggle');
  
  if (!miniCart || !cartToggle) return;

  miniCart.addEventListener('click', function(event) {
    if (event.target.closest('[data-close-cart]')) {
      event.preventDefault();
      event.stopPropagation();
      closeMiniCart();
      return;
    }

    if (event.target === this) {
      closeMiniCart();
    }
  });

  const miniCartInner = miniCart.querySelector('.mini-cart-body');
  if (miniCartInner) {
    miniCartInner.addEventListener('click', function(event) {
      event.stopPropagation();
    });
  }

  function closeMiniCart() {
    miniCart.setAttribute('aria-hidden', 'true');
    cartToggle.setAttribute('aria-expanded', 'false');
    
    const cartIcon = cartToggle.querySelector('.header__cart-icon');
    if (cartIcon) {
      cartIcon.setAttribute('aria-expanded', 'false');
    }

    document.removeEventListener('click', handleDocumentClick);
  }

  function openMiniCart() {
    miniCart.setAttribute('aria-hidden', 'false');
    cartToggle.setAttribute('aria-expanded', 'true');
    
    const cartIcon = cartToggle.querySelector('.header__cart-icon');
    if (cartIcon) {
      cartIcon.setAttribute('aria-expanded', 'true');
    }

    setTimeout(() => {
      document.addEventListener('click', handleDocumentClick);
    }, 0);
  }

  function handleDocumentClick(event) {
    if (!miniCart.contains(event.target) && !cartToggle.contains(event.target)) {
      closeMiniCart();
    }
  }

  cartToggle.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const isCartOpen = miniCart.getAttribute('aria-hidden') === 'false';
    
    if (isCartOpen) {
      closeMiniCart();
    } else {
      openMiniCart();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && miniCart.getAttribute('aria-hidden') === 'false') {
      closeMiniCart();
    }
  });
}); 



// Bon widget translations.

document.addEventListener("DOMContentLoaded", function() {

  var iframe = document.getElementById('bon-app-iframe');
  var langValue = document.documentElement.lang;
  var loyaltyBtn = document.getElementById('bon-loyalty-btn');
  if(loyaltyBtn !== null){
      var loyaltyBtnText = loyaltyBtn.querySelector('span')

      if (langValue === 'en') {
          loyaltyBtnText.textContent = 'Rewards'
      } else if (langValue === 'de') {
          loyaltyBtnText.textContent = 'Belohnung'
      }

      if (iframe) {

          var currentContentSrc = iframe.getAttribute('content-src');
          var newContentSrc = currentContentSrc.replace(/(lang=)[^&]+/, '$1' + langValue);

          iframe.setAttribute('content-src', newContentSrc);
      }
  }
});

//nova
document.addEventListener('DOMContentLoaded', function() {

  //nova in mini cart popup
  document.body.addEventListener('click', function(e) {
      if (document.querySelectorAll('#nova-poshta') !== null && document.querySelector('.nova-feature-btn__wrapper') !== null) {
          if (e.target.closest('.nova-feature-btn__wrapper')) {
              document.querySelector('.mini-cart__inner #nova-poshta').classList.remove('d-none');
          } else if (!e.target.closest('.nova-feature-btn__wrapper') && !e.target.closest('.mini-cart__inner #nova-poshta') && !e.target.classList.contains('link') || e.target.closest('.mini-cart__inner #nova-poshta .form__close')) {
              document.querySelector('.mini-cart__inner #nova-poshta').classList.add('d-none');
          }
      }
  })
});
//nova END

// nova API requests
function initNova() {
  const novaPoshta = document.querySelector('#nova-poshta');
  const addressWrap = novaPoshta.querySelector('.address-wrap');
  const warehouseWrap = novaPoshta.querySelector('.warehouse-wrap');
  const cityFilter = novaPoshta.querySelector('#city_filter');
  const citySearch = novaPoshta.querySelector('#city-search');
  const warehouseFilter = novaPoshta.querySelector('#warehouse_filter');
  const streetFilter = novaPoshta.querySelector('#street_filter');

  const apiKey = '9d51757505fed1609fa05360d3802787';
  const apiUrlN = 'https://api.novaposhta.ua/v2.0/json/ ';

  quickCityLink();
  clearFields();
  deliveryMethod();
  initCartUrl();

  async function reqAPI(data) {
      try {
          const response = await fetch(apiUrlN, {
              method: 'POST',
              body: JSON.stringify(data),
              credentials: 'same-origin',
              cache: 'no-cache',
              mode: 'cors',
              headers: {
                  'Content-Type': 'application/json'
              }
          });
          return response.json();
      } catch (error) {
          //throw error;
          console.log('error');
      }
  }

  novaPoshta.querySelectorAll('input.form-control').forEach(function(item) {
      item.addEventListener('input', function() {
          if (item.value != '') {
              if (item.classList.contains('input-city')) {
                  item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                  let customerCity = item.value;
                  reqAPI({
                      "apiKey": apiKey,
                      "modelName": "Address",
                      "calledMethod": "searchSettlements",
                      "methodProperties": {
                          "CityName": customerCity,
                          "Limit": "99",
                          "Page": "1"
                      }
                  })
                      .then(res => {
                          if (res.success) {
                              let dataCities = res.data[0].Addresses;
                              cityFilter.innerHTML = '';
                              if (dataCities.length > 0) {
                                  dataCities.forEach(function(item, i) {
                                      cityFilter.insertAdjacentHTML('beforeend', `
                                              <a class="filter-link city-link link" data-city="${item.MainDescription}" data-delivery-ref="${item.DeliveryCity}" data-ref="${item.Ref}" data-present="${item.Present}" style="display:block;">${item.Present}</a>
                                          `)
                                  })
                              }
                              cityFilter.classList.add('active');
                              cityFilterLink();
                          }
                      })
                      .catch(err => {
                          console.log('error request:', this)
                      })
              } else if (item.classList.contains('input-warehouse') && citySearch.value != '') {
                  item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                  let findString = item.value;
                  let CityRef = citySearch.dataset.deliveryRef;
                  reqAPI({
                      "apiKey": apiKey,
                      "modelName": "Address",
                      "calledMethod": "getWarehouses",
                      "methodProperties": {
                          "FindByString": findString,
                          "CityRef": CityRef,
                          "Page": "1",
                          "Limit": "99"
                      }
                  })
                      .then(res => {
                          if (res.success) {
                              let warehouses = res.data;
                              warehouseFilter.innerHTML = '';
                              warehouses.forEach(function(item, i) {
                                  warehouseFilter.insertAdjacentHTML('beforeend', `
                                          <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.Description}' style="display:block;">${item.Description}</a>
                                      `)
                              })
                              warehouseFilter.classList.add('active');
                              cityFilterLink();
                          }
                      })
                      .catch(err => {
                          console.log('error request:', this)
                      })
              } else if (item.classList.contains('input-street') && citySearch.value != '') {
                  item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                  let findString = item.value;
                  let сityRef = citySearch.dataset.deliveryRef;
                  reqAPI({
                      "apiKey": apiKey,
                      "modelName": "Address",
                      "calledMethod": "getStreet",
                      "methodProperties": {
                          "CityRef": сityRef,
                          "FindByString": findString,
                          "Page": "1",
                          "Limit": "99"
                      }
                  })
                      .then(res => {
                          if (res.success) {
                              let dataStreets = res.data;
                              streetFilter.innerHTML = '';
                              dataStreets.forEach(function(item, i) {
                                  streetFilter.insertAdjacentHTML('beforeend', `
                                          <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.StreetsType} ${item.Description}' style="display:block;">${item.StreetsType} ${item.Description}</a>
                                      `)
                              })
                              streetFilter.classList.add('active');
                              cityFilterLink();
                          }
                      })
                      .catch(err => {
                          console.log('error request:', this)
                      })
              }
          } else {
              item.dataset.ref = '';
              if (item.closest('.form-group').querySelector('.clear') !== null) {
                  item.closest('.form-group').querySelector('.clear').classList.add('d-none')
              }
              item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
              item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
          }
      })
  })

  function clearFields() {
      novaPoshta.querySelectorAll('.clear').forEach(function(item) {
          item.addEventListener('click', function() {
              item.classList.add('d-none');
              item.closest('.branch_wrap').querySelector('input').value = '';
              item.closest('.branch_wrap').querySelector('input').dataset.ref = '';
              item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
              item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active')
          });
      });
  }

  function quickCityLink() {
      novaPoshta.querySelectorAll('a.quick-city-link').forEach(function(item) {
          let startCity = item.textContent;
          reqAPI({
              "apiKey": apiKey,
              "modelName": "Address",
              "calledMethod": "searchSettlements",
              "methodProperties": {
                  "CityName": startCity,
                  "Limit": "99",
                  "Page": "1"
              }
          })
              .then(res => {
                  if (res.success) {
                      item.dataset.ref = res.data[0].Addresses[0].Ref;
                      item.dataset.deliveryRef = res.data[0].Addresses[0].DeliveryCity;
                      item.dataset.present = res.data[0].Addresses[0].Present;
                  }
              })
              .catch(err => {
                  console.log('error request:', this)
              })
          item.addEventListener('click', function(e) {
              if (e.target.closest('.quick-city-link')) {
                  novaPoshta.querySelector('.city-wrap input').value = item.textContent;
                  novaPoshta.querySelector('.city-wrap input').dataset.ref = ititem.textContentf;
                  novaPoshta.querySelector('.city-wrap input').dataset.deliveryRef = item.textContent;
                  novaPoshta.querySelector('.city-wrap .clear').classList.remove('d-none');
              }
          })
      })
  }

  function cityFilterLink() {
      novaPoshta.querySelectorAll('a.filter-link').forEach(function(item) {
          item.addEventListener('click', function(e) {
              if (e.target.dataset.deliveryRef) {
                  item.closest('.branch_wrap').querySelector('.form-group input').dataset.deliveryRef = e.target.dataset.deliveryRef;
              }
              if (e.target.dataset.city) {
                  item.closest('.branch_wrap').querySelector('.form-group input').dataset.city = e.target.dataset.city;
              }
              item.closest('.branch_wrap').querySelector('.form-group input').dataset.ref = e.target.dataset.ref;
              item.closest('.branch_wrap').querySelector('.form-group input').value = e.target.dataset.present;
              item.closest('.branch_wrap').querySelector('.form-group .clear').classList.remove('d-none');
              item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
              item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
          })
      })
  }

  function deliveryMethod() {
      document.querySelectorAll('[name="variant"]').forEach(function(item) {
          item.addEventListener('change', function(e) {
              if (e.target.closest('#variant-branch')) {
                  addressWrap.classList.add('d-none');
                  warehouseWrap.classList.remove('d-none');
                  novaPoshta.querySelector('#address-street').value = '';
                  novaPoshta.querySelector('#address-street').dataset.ref = '';
                  novaPoshta.querySelector('#address-build').value = '';
                  novaPoshta.querySelector('#address-flat').value = '';
                  addressWrap.querySelector('.clear').classList.add('d-none');
              } else if (e.target.closest('#variant-courier')) {
                  addressWrap.classList.remove('d-none');
                  warehouseWrap.classList.add('d-none');
                  novaPoshta.querySelector('#warehouse-search').value = '';
                  novaPoshta.querySelector('#warehouse-search').dataset.ref = '';
                  warehouseWrap.querySelector('.clear').classList.add('d-none');
              }
          })
      })
  }

  function initCartUrl() {
      let inputsData = document.querySelectorAll('#nova-poshta .form-control');
      let inputsTypeShip = document.querySelectorAll('#nova-poshta input[name="variant"]');
      let buttCartLink = document.querySelector('#nova-poshta .nova-poshta__button-wrapper a');
      buttCartLink.addEventListener('click', function(e) {
          e.preventDefault();
          if (novaPoshta.querySelector('.dropdown-filter.active') == null) {
              inputsTypeShip.forEach(function(inputTypeShip, i) {
                  var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
                      .then(response => response.json())
                      .then(data => {
                          return data
                      });
                  function getCookie(name) {
                      const nameEQ = name + "=";
                      const cookies = document.cookie.split(';');
                      for (let i = 0; i < cookies.length; i++) {
                          let cookie = cookies[i];
                          while (cookie.charAt(0) === ' ') {
                              cookie = cookie.substring(1);
                          }
                          if (cookie.indexOf(nameEQ) === 0) {
                              return cookie.substring(nameEQ.length, cookie.length);
                          }
                      }
                      return null;
                  }
                  const couponCode = getCookie('coupon-discount');
                  if (inputTypeShip.checked && inputTypeShip.dataset.type == 'branch' && checkInputs('branch') == 2) {
                      let arrInputs = checkInputs('branch', true);
                      if (arrInputs) {
                          let linkCheckout;
                          cartContents.then((value) => {
                              let cart = value;
                              let link = 'http://' + window.Shopify.shop + '/cart/';
                              cart.items.forEach((item, i) => {
                                  link += item.variant_id + ':' + item.quantity
                                  if (i != cart.items.length - 1) {
                                      link += ','
                                  }
                              })
                              if(couponCode !== null){
                                  link += '?' + 'checkout[shipping_address][city]=' + arrInputs[0].value + '&checkout[shipping_address][address1]=' + arrInputs[1].value + '&checkout[shipping_address][zip]=12345' + `&discount=${encodeURIComponent(couponCode)}`;
                              }else{
                                  link += '?' + 'checkout[shipping_address][city]=' + arrInputs[0].value + '&checkout[shipping_address][address1]=' + arrInputs[1].value + '&checkout[shipping_address][zip]=12345';
                              }
                              window.open(link, '_top')
                          })

                      }
                  } else if (inputTypeShip.checked && inputTypeShip.dataset.type == 'courier' && checkInputs('courier') == 4) {
                      let checkedInputs = checkInputs('courier', true);
                      if (checkedInputs) {
                          let linkCheckout;
                          cartContents.then((value) => {
                              let cart = value;
                              let link = 'http://' + window.Shopify.shop + '/cart/';
                              cart.items.forEach((item, i) => {
                                  link += item.variant_id + ':' + item.quantity
                                  if (i != cart.items.length - 1) {
                                      link += ','
                                  }
                              })
                              if(couponCode !== null){
                                  link += '?' + 'checkout[shipping_address][city]=' + checkedInputs[0].value + '&checkout[shipping_address][address1]=' + checkedInputs[1].value + ', буд. ' + checkedInputs[2].value + ', кв. ' + checkedInputs[3].value + '&checkout[shipping_address][zip]=12345' + `&discount=${encodeURIComponent(couponCode)}`;
                              }else {
                                  link += '?' + 'checkout[shipping_address][city]=' + checkedInputs[0].value + '&checkout[shipping_address][address1]=' + checkedInputs[1].value + ', буд. ' + checkedInputs[2].value + ', кв. ' + checkedInputs[3].value + '&checkout[shipping_address][zip]=12345';
                              }
                              window.open(link, '_top')
                          })
                      }
                  }
              })
          } else {
              console.log('select dates')
          }
      })

      function checkInputs(type, inputs) {
          if (type == 'branch') {
              let branch = 0;
              let arr = [];
              inputsData.forEach((item) => {
                  if ((item.id == 'city-search' || item.id == 'warehouse-search') && item.value != '') {
                      branch++;
                      arr.push(item);
                  }
              })
              if (inputs == true) {
                  return arr;
              } else {
                  return branch;
              }
          } else if (type == 'courier') {
              let courier = 0;
              let arr = [];
              inputsData.forEach((item) => {
                  if ((item.id == 'city-search' || item.id == 'address-street' || item.id == 'address-build' || item.id == 'address-flat') && item.value != '') {
                      courier++;
                      arr.push(item);
                  }
              })
              if (inputs == true) {
                  return arr;
              } else {
                  return courier;
              }
          }
      }
  }

}
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('#nova-poshta') !== null && document.querySelector('.nova-feature-btn__wrapper') == null) {
      initNova();
  }
});
// nova API requests END

// Fix for recently viewed products
document.addEventListener('DOMContentLoaded', function() {
  // Initialize localStorage if it doesn't exist
  if (localStorage.getItem('recentlyViewedProducts') === null) {
    localStorage.setItem('recentlyViewedProducts', JSON.stringify([]));
  }
  
  // Make sure it's valid JSON
  try {
    JSON.parse(localStorage.getItem('recentlyViewedProducts'));
  } catch (e) {
    localStorage.setItem('recentlyViewedProducts', JSON.stringify([]));
  }

  // Fix _getSearchQueryString method in RecentlyViewedProductsSection
  const fixRecentlyViewedSearch = function() {
    if (window.RecentlyViewedProductsSection) {
      const originalMethod = window.RecentlyViewedProductsSection.prototype._getSearchQueryString;
      
      window.RecentlyViewedProductsSection.prototype._getSearchQueryString = function() {
        let items;
        try {
          items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
          
          // Initialize localStorage if empty or invalid
          if (!items || !Array.isArray(items)) {
            items = [];
            localStorage.setItem("recentlyViewedProducts", JSON.stringify(items));
          }
        } catch (e) {
          items = [];
          localStorage.setItem("recentlyViewedProducts", JSON.stringify(items));
        }

        // Filter out current product and ensure no duplicates
        if (this.options && this.options["currentProductId"] && items.includes(this.options["currentProductId"])) {
          items.splice(items.indexOf(this.options["currentProductId"]), 1);
        }
        
        // Remove duplicates
        items = items.filter((value, index, self) => self.indexOf(value) === index);
        
        if (items.length === 0) {
          return "";
        }
        
        return items.map((item) => {
          return "id:" + item;
        }).join(" OR ");
      };
    }
  };

  // Try to fix immediately and also try again after 1 second in case scripts load in a different order
  fixRecentlyViewedSearch();
  setTimeout(fixRecentlyViewedSearch, 1000);
});